<template>
    <div id="fUser" v-loading.fullscreen.lock="visible.loading" element-loading-background="rgba(0, 0, 0, 0.4)">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-calendar"></i> 系统管理</el-breadcrumb-item>
                <el-breadcrumb-item>修改密码</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

		<el-form ref="infoDialog" :model="data.info" label-width="130px">
			<el-form-item label="登陆ID:">
				<el-input v-model="data.oldpwd"  placeholder="旧登录密码" show-passwordsize="large"></el-input>
			</el-form-item>
			<el-form-item label="用户名称:">
				<el-input v-model="data.newpwd1" placeholder="新登录密码" show-password size="large"></el-input>
			</el-form-item>
			<el-form-item label="登陆密码:">
				<el-input v-model="data.newpwd2" placeholder="重复新登录密码" show-password size="large"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" icon="el-icon-search" @click="save">保存密码</el-button>
			</el-form-item>
		</el-form>
    </div>
</template>

<script>
    export default {
        name: 'changepwd',
        data() {
            return {
                data: {
                    oldpwd: '',
                    newpwd1: '',
                    newpwd2: ''
                }
            }
        },
        methods: {
            save() {
				let vue = this;
				vue.visible.loading = true;
				window.ax.post('api/system/user/changepwd', {
					Sign: window.$gloable.userinfo.sign,
					
				}).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						vue.search();
						vue.clearAndCloseInfo();
						vue.$message.success((status ? '停用' : '启用') + '成功');
					} else {
						vue.$message.error(data.Message);
					}
					vue.visible.loading = false;
				}).catch(err => {
					vue.$message.error('执行脚本出错，请联系管理员');
					vue.visible.loading = false;
				});
			}
        },
        created() {
			
        },
        mounted() {}
    }
</script>

<style scoped>
</style>
